import React, {forwardRef, useImperativeHandle} from "react";
import {useQueryClient} from "react-query";
import __ from "lodash";
import {useComboValues} from "../services/settings";


const ComboValues = forwardRef((props, ref) => {

  const queryClient = useQueryClient();
  const extraKeys = __.pick(props, ['group', 'subGroup']);
  const updateValues = props.updateValues;

  const comboValues = useComboValues({queryClient, extraKeys: Object.values(extraKeys), useCache: true});


  useImperativeHandle(ref, () => {
    let value = {};

    return {
      // the final value to send to the grid, on completion of editing
      getValue() {
        return value;
      },
      // Gets called once before editing starts, to give editor a chance to
      // cancel the editing before it even starts.
      isCancelBeforeStart() {
        return false;
      },

      // Gets called once when editing is finished (eg if enter is pressed).
      // If you return true, then the result of the edit will be ignored.
      isCancelAfterEnd() {
        return false;
      },

      afterGuiAttached () {
        //inputRef.current.focus();
      },
    }
  });

  if (comboValues && comboValues.data && updateValues) {
    let returnObject = {} ;
    let option = __.find(comboValues.data, {code: props.value});
    if (option) {
      returnObject = option;
    } else {
      option = __.find(comboValues.data, {value: props.value});
      if (option)
        returnObject = option;
    }
    updateValues(props.updateParams, returnObject);
  }

  return ( <></> );
})

export default ComboValues;